<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("fnb_label", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("label_fnb_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          v-if="isEditable"
          variant="default"
          class="btn-blue"
          @click="() => updateOrder()"
          >{{ $t("Save") }}</b-button
        >
        <b-button
          v-else
          variant="default"
          class="btn-blue"
          @click="() => editOrder()"
          >{{ $t("Edit order") }}</b-button
        >
        <b-button variant="default" to="add-fnb-label" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:500="getLabelList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown
            :text="filterButtonTitle"
            variant="dropdown-curve"
            class="ml-auto mr-3 filter-dropdown"
          >
            <b-dropdown-item
              v-for="(status, statusIndex) in statuses"
              :key="statusIndex"
              v-on:click="filterStatus(status.status)"
              >{{ status.status }}</b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'label_name'"
              @click="onSortValue('label_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('label_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('label_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("fnb_label", 1) }}
          </th>
          <th>{{ $t("shortcode") }}</th>
          <th>{{ $t("type") }}</th>
          <th>{{ $t("order") }}</th>
        </tr>
      </thead>
      <template v-if="Labels && Labels.length > 0">
        <draggable
          :list="Labels"
          tag="tbody"
          @end="endSort($event)"
          :move="draggableElements"
        >
          <tr v-for="(item, key) in Labels" :key="key">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <!-- Status Dot Component -->
                <StatusDot
                  :status="item.label_is_active == 'Y' ? 'active' : 'inactive'"
                />

                <!-- Edit Icon with Tooltip -->
                <span
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                  @click="goToRoute('/master/edit-fnb-label', item)"
                >
                  <span class="edit-pen ml-2 blue-icon cursor-pointer"></span>
                </span>
              </div>
            </td>

            <td>{{ $tc(item.label_name, 1) }}</td>
            <td>{{ item.label_short_code || "-" }}</td>
            <td>{{ item.type_name || "-" }}</td>
            <td>{{ item.order || "-" }}</td>

            <!-- <td>
            <div class="d-flex align-items-center justify-content-end">
              <StatusDot
                :status="item.label_is_active == 'Y' ? 'active' : 'inactive'"
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-fnb-label', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          </tr>
        </draggable>
      </template>

      <tbody v-if="Labels.length == 0">
        <tr>
          <td colspan="3">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="Labels.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Crews from "@/helper/formJSONMaster/Crews";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import draggable from "vuedraggable";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
    draggable,
  },
  data() {
    return {
      perPage: 10,
      isEditable: false,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      filterButtonTitle: "Active",
      statuses: [
        { status: "Active" },
        { status: "Inactive" },
        { status: "All" },
      ],
      selectedStatus: "Active",
      gridView: false,
      listView: true,
      Labels: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "label_name",
    };
  },
  beforeMount() {
    this.getLabelList();
    this.getviewingnumber();
  },
  methods: {
    draggableElements: function () {
      return this.isEditable;
    },
    filterStatus: function (status) {
      this.filterButtonTitle = status;
      this.selectedStatus = status;
      this.isEditable = false;
      this.getLabelList();
    },
    endSort(event) {
      this.Labels.map((x, index) => {
        if (this.currentPage != 1) {
          x.order = this.perPage * (this.currentPage - 1) + (index + 1);
        } else {
          x.order = index + 1;
        }
      });
      console.log("this.sorted Labels", this.Labels);
      console.log("this.event", event);
    },
    editOrder: function () {
      this.isEditable = true;
      if (this.isEditable) {
        this.filterButtonTitle = "Active";
        this.selectedStatus = "Active";
        this.onDropDownChangeValue("All");
        this.$forceUpdate();
      }
    },
    updateOrder: function () {
      this.isEditable = false;
      let payload = {
        Labels: this.Labels,
      };
      console.log("In update section", this.Labels);
      MasterService.UpdateFnbLabelsOrder(payload)
        .then((data) => {
          if (data && data.status) {
            this.onDropDownChangeValue("10");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getLabelList();
      } else {
        this.currentPage = event;
        this.getLabelList();
      }
    },
    goToRoute: function (path, item) {
      const { label_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: label_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getLabelList();
    },
    getLabelList: function () {
      this.Labels = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        orderBy: this.orderby,
        columnName: this.columnName,
        status: this.selectedStatus,
      };
      MasterService.getAllFnbLabels(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Labels = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/FNBLabelComponents/listFNBLabels.vue